export { PAGINATION_DEFAULTS } from '@/plugins/app/api/helpers/pagination.helpers'
export { buildQueryFilters } from '@/plugins/app/api/helpers/query-builder.helpers'
export { createApiHook } from '@/plugins/app/api/composables/api-hook.composable'

export { useGetCities, type CitiesFilters, DEFAULT_FILTERS as CITIES_DEFAULT_FILTERS } from '@/plugins/app/api/services/cities.service'
export { useGetCountries } from '@/plugins/app/api/services/countries.service'
export { useGetDiagnoses, type DiagnosesFilters, DEFAULT_FILTERS as DIAGNOSES_DEFAULT_FILTERS } from '@/plugins/app/api/services/diagnoses.service'
export { useGetExaminationTypes } from '@/plugins/app/api/services/examination-types.service'
export { useGetHintGroup } from '@/plugins/app/api/services/hint-group.service'
export { useGetAllHintGroup } from '@/plugins/app/api/services/hint-group.service'
export { useGetInsuranceCompanies } from '@/plugins/app/api/services/insurance-companies.service'
export { useGetLaboratories } from '@/plugins/app/api/services/laboratories.service'
export { useGetOffers } from '@/plugins/app/api/services/offers.service'
export { useGetProducts, type ProductsFilters, DEFAULT_FILTERS as PRODUCTS_DEFAULT_FILTERS } from '@/plugins/app/api/services/products.service'

export const STALE_TIME = 60000 * 3